<script setup lang="ts">
import type { ComponentGridProps } from "./ComponentGrid.props"
const props = defineProps<ComponentGridProps>()
</script>

<template>
  <div class="padded py-5 md:py-10">
    <ProductBlocksBrandsSuggestionsBlock v-if="props" v-bind="props" />
  </div>
</template>
